import router from '@/router/index'

export default function (Vue) {
  Vue.auth = {
    user: {
      authenticated: false,
      id: 0,
      email: ''
    },
    setToken (token) {
      localStorage.setItem('token', token)
    },
    getToken () {
      return localStorage.getItem('token')
    },

    isAuthenticated () {
      if (this.getToken()) {
        return true
      } else {
        return false
      }
    },

    getUserInfo () {
      return new Promise((resolve, reject) => {
        axios.get('/users/me')
          .then(({data}) => {
            this.user = data.data
            resolve(data.data)
          }, (data) => {
            reject(data)
          })
      })
    },

    logout () {
      let token = this.getToken()

      if (token) {
        this.user = {}
        localStorage.removeItem('token')
      }

      router.push({name: 'login'})
    }
  }

  Object.defineProperties(Vue.prototype, {
    $auth: {
      get: () => {
        return Vue.auth
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/model/Auth.js